var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 351.098 566.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "maskPath",
    d: "M2186.325,8191.366s-127.227,140.814-139.242,242.55,9.77,122.848,51.654,145.979,196.736,47.164,236.487,76.359,53.9,99.49,53.9,99.49",
    transform: "translate(-2040.968 -8189.354)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maskReveal",
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M2186.325,8191.366s-127.227,140.814-139.242,242.55,9.77,122.848,51.654,145.979,196.736,47.164,236.487,76.359,53.9,99.49,53.9,99.49",
    transform: "translate(-2040.968 -8189.354)",
    fill: "none",
    stroke: "#ff4b4b",
    strokeWidth: 6,
    strokeDasharray: "8 5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath2);
export default __webpack_public_path__ + "static/media/path-2.0bbd6ff2.svg";
export { ForwardRef as ReactComponent };